import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const CardContainer = styled.div`
  width: ${pxToRem(481)};
  height: ${pxToRem(193)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${pxToRem(24)} ${pxToRem(38)} ${pxToRem(24)} ${pxToRem(38)};

  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};

  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06);
  background: rgb(255, 255, 255);
  transition: all 0.5s ease;

  &:hover {
    transform: translateY(${pxToRem(-3)});
  }
`;

export const DocumentTitle = styled.h4`
  align-self: start;
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(24)};
  font-weight: 700;
`;

export const IconsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
`;

export const Icon = styled.img`
  width: ${pxToRem(46)};
  height: ${pxToRem(46)};
  transition: all 0.5s ease;

  &:hover {
    transform: translateY(${pxToRem(-3)});
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
